import React, { useState, useEffect } from 'react';
import './EstatesSection.css';

const EstatesSection = () => {
  const estates = [
    {
      name: 'Beryl Ibadan',
      location: 'Ibadan, Oyo State, Nigeria',
      description: 'A smart city development featuring modern infrastructure, green spaces, and cutting-edge technology. Located in the heart of Ibadan with easy access to major landmarks.',
      features: [
        'Smart Estate Technology',
        'Green Estate Design',
        'Central Sewage System',
        '24/7 Power Supply',
        'Gated Community',
        'Security Systems',
        'Treated Water',
        'Good Road Network',
        'Play Area',
        'Gym Facilities'
      ],
      title: 'C OF O (Certificate of Occupancy)',
      plotSize: '400 SQM',
      image: '/images/beryl_ibadan.jpg'
    },
    {
      name: 'Beryl Ibeju Lekki',
      location: 'Ibeju Lekki, Lagos, Nigeria',
      description: 'A premier smart city development in Ibeju Lekki. Featuring advanced infrastructure, smart technology integration, and premium amenities for modern living.',
      features: [
        'Smart City Technology',
        'Advanced Infrastructure',
        'Green Estate Design',
        'Central Sewage System',
        '24/7 Power Supply',
        'Gated Community',
        'Security Systems',
        'Treated Water',
        'Good Road Network',
        'Play Area',
        'Gym Facilities'
      ],
      title: 'GAZETTE',
      plotSize: '400 SQM',
      image: '/images/beryl_ibejulekki.jpg'
    },
    {
      name: 'Beryl Abeokuta',
      location: 'Abeokuta, Ogun State, Nigeria',
      description: 'Premium estate development in Abeokuta offering modern infrastructure and smart city features. Perfect for investors looking for premium land with flexible payment plans.',
      features: [
        'Premium Land Investment',
        'Flexible Payment Plans',
        'Smart Estate Features',
        'Green Estate Design',
        'Gated Community',
        'Security Systems',
        'Good Road Network',
        '24/7 Power Supply',
        'Treated Water',
        'Central Sewage System'
      ],
      title: 'C OF O (Certificate of Occupancy)',
      plotSize: '400 SQM',
      image: '/images/beryl_abeokuta.jpg'
    }
  ];

  return (
    <section id="estates" className="estates-section section">
      <div className="container">
        <h2 className="section-title">Our Estates</h2>
        <p className="section-subtitle">
          Explore our premium real estate developments across prime locations
        </p>
        
        <div className="estates-grid">
          {estates.map((estate, index) => (
            <div key={index} className="estate-card card">
              {estate.images && estate.images.length > 0 ? (
                <EstateImageSlider images={estate.images} estateName={estate.name} />
              ) : estate.image ? (
                <div className="estate-image-container">
                  <img 
                    src={estate.image} 
                    alt={estate.name}
                    className="estate-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              ) : null}
              <div className="estate-header">
                <h3 className="estate-name">{estate.name}</h3>
                <p className="estate-location">
                  <span className="location-icon">📍</span> {estate.location}
                </p>
              </div>
              
              <p className="estate-description">{estate.description}</p>
              
              <div className="estate-details">
                <div className="detail-item">
                  <strong>Title:</strong> {estate.title}
                </div>
                <div className="detail-item">
                  <strong>Plot Size:</strong> {estate.plotSize}
                </div>
              </div>
              
              <div className="estate-features">
                <h4>Key Features:</h4>
                <ul className="features-list">
                  {estate.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Image Slider Component for estates with multiple images
const EstateImageSlider = ({ images, estateName }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageErrors, setImageErrors] = useState({});

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  // Handle image load errors
  const handleImageError = (index) => {
    setImageErrors((prev) => ({ ...prev, [index]: true }));
  };

  // Filter out images that failed to load
  const validImages = images.filter((_, index) => !imageErrors[index]);

  // If no valid images, show gradient background
  if (validImages.length === 0) {
    return <div className="estate-image-container" />;
  }

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? validImages.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === validImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="estate-image-slider">
      <div className="slider-container">
        {validImages.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''}`}
          >
            <img
              src={image}
              alt={`${estateName} - Image ${index + 1}`}
              className="estate-image"
              onError={() => handleImageError(index)}
            />
          </div>
        ))}
        
        {/* Navigation arrows */}
        {validImages.length > 1 && (
          <>
            <button 
              className="slider-arrow slider-arrow-left" 
              onClick={goToPrevious}
              aria-label="Previous image"
            >
              ‹
            </button>
            <button 
              className="slider-arrow slider-arrow-right" 
              onClick={goToNext}
              aria-label="Next image"
            >
              ›
            </button>
          </>
        )}
      </div>
      
      {/* Dots indicator */}
      {validImages.length > 1 && (
        <div className="slider-dots">
          {validImages.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EstatesSection;

